module.exports = __webpack_public_path__ + "static/img/2.5e7c719.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/2.png
// module id = Iz3u
// module chunks = 0